import { RelationShipService } from "./../../core/http/service/RelationShipService";
import BaseResponse from "../../models/core/BaseResponse";
import { array } from "yup";
import { CompanyService } from "../../core/http/service/CompanyService";
import OccupationalHealth from "../../models/core/occupationalHealth/OccupationalHealth";

export const FETCH_RELATIONSHIP = "FETCH_RELATIONSHIP";
export const FILTER_RELATIONSHIP = " FILTER_RELATIONSHIP";
export const FILTER_RELATIONSHIPGHE = " FILTER_RELATIONSHIPGHE";

const sendToAnalytics = (action: string = "", error: any = null) => {
  console.error(action, error);
};

const gheList = async (companyId: string) => {
  const service: CompanyService = new CompanyService()

  const responseGHE: any = await service.getCompanySaudeOcupacional(companyId)
  const baseResponseGHE: BaseResponse<any> = new BaseResponse().fromJSON({...responseGHE.data})
  const saudesOcupacionais: OccupationalHealth[] = []

  baseResponseGHE.data.forEach((data: any)=>{
    saudesOcupacionais.push(new OccupationalHealth().fromJSON({...data}))
  })

  return saudesOcupacionais;    
}

export const getAllRelationShip = async (companyId: string, OccupationalHealthList: OccupationalHealth[]) => {
  const relationShipService: RelationShipService = new RelationShipService();
    try {
      const arrayRelationOne: any[] = [];

      const response: any = await relationShipService.getRelationShipGhe(
        companyId
      );

      let saudesOcupacionais: OccupationalHealth[];
      if(OccupationalHealthList.length === 0){
        saudesOcupacionais = await gheList(companyId);
      }
      else {
        saudesOcupacionais = OccupationalHealthList;
      }

      const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON({
        ...response.data,
      });

      const responseTwo: any = await relationShipService.FetchRelationShipAll(
        companyId
      );
      const baseResponseTwo: BaseResponse<any> = new BaseResponse().fromJSON({
        ...responseTwo.data,
      });

      baseResponse.data.postos.forEach((relacaoPosto: any) => {
        let object = {};
        const relation = baseResponseTwo.data.filter((relation: any) => {
          return relacaoPosto.postoTrabalhoId === relation.id;
        });
        const postoTrabalho = relation[0];

        if (relacaoPosto.id !== null) {
          const saudeOcupacionalList = saudesOcupacionais.filter(
            (saude: any) => {
              return saude.id === relacaoPosto.saudeOcupacionalId;
            }
          );
          const saudeOcupacional = saudeOcupacionalList[0];
          object = {
            id: relacaoPosto.id,
            postoTrabalhoId: postoTrabalho.id,
            postoTrabalhoNome: postoTrabalho.nome,
            saudeOcupacional: {
              nome: saudeOcupacional?.nome,
              id: saudeOcupacional?.id,
            },
          };
        } else {
          object = {
            id: null,
            postoTrabalhoId: postoTrabalho.id,
            postoTrabalhoNome: postoTrabalho.nome,
            saudeOcupacional: { nome: "Não relacionado", id: "" },
          };
        }
        arrayRelationOne.push(object);
      });

      return arrayRelationOne
      
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
};


export const FetchRelationship = (companyId: string, OccupationalHealthList: OccupationalHealth[]) => {

  return async (dispatch: any) => {
    const arraySaude: any[] = [];
    const arraySaudeMenu: any[] = [];

    try {

      let saudesOcupacionais: OccupationalHealth[];
      if(OccupationalHealthList.length === 0){
        saudesOcupacionais = await gheList(companyId);
      }
      else {
        saudesOcupacionais = OccupationalHealthList;
      }

      const listArray = await getAllRelationShip(companyId, saudesOcupacionais);     
    
      saudesOcupacionais.forEach((data: any) => {
        arraySaude.push({ ...data });
        arraySaudeMenu.push({ ...data });
      });

      arraySaudeMenu.push({ id: "", empresaId: "", nome: "Todos" });

      dispatch({
        type: FETCH_RELATIONSHIP,
        arrayOneRelationShip: listArray,
        arraySaude: arraySaude,
        arraySaudeMenu: arraySaudeMenu,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const filterRelationShipList = (companyId: string, searchQuery: string, occupationalHealthList: OccupationalHealth[]) => {
  return async (dispatch: any) => {
    try {

      const listArray = await getAllRelationShip(companyId, occupationalHealthList);
      
      const listaFiltrada = [
        ...listArray.filter((list: any) => {
          const hasNome = list.postoTrabalhoNome
            .toUpperCase()
            .indexOf(searchQuery.toUpperCase());

          if (hasNome !== -1) return true;

          return false;
        }),
      ];

      

      dispatch({
        type: FILTER_RELATIONSHIP,
        arrayOneRelationShip: listaFiltrada,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const filterGhes = (
  companyId: string,
  arraySaude: any,
  searchQuery: any,
  occupationalHealthList: OccupationalHealth[]
) => {
  return async (dispatch: any) => {
    try {

      const listArray = await getAllRelationShip(companyId, occupationalHealthList);

      if (!(searchQuery instanceof Array)) {
        const queryName = searchQuery.nome;

        const listaFiltrada = [
          ...arraySaude.filter((list: any) => {
            const hasNome = list.nome
              .toUpperCase()
              .indexOf(queryName.toUpperCase());

            if (hasNome !== -1) return true;

            return false;
          }),
        ];

        const idGhe = listaFiltrada.length > 0 ? listaFiltrada[0].id : "";

        const listAllGhes = listArray.filter((d: any) =>
          d.saudeOcupacional.id.includes(idGhe)
        );

        dispatch({
          type: FILTER_RELATIONSHIPGHE,
          arrayOneRelationShip: listAllGhes,
        });
      }
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const updateRelationShip = (
  idEmpresa: string,
  idRelation: string,
  idPosto: string,
  idSaude: string
) => {
  const service: RelationShipService = new RelationShipService();
  return async () => {
    try {
      if (idRelation === null) {
        const bodyRequest = {
          postoTrabalhoId: idPosto,
          saudeOcupacionalId: idSaude,
        };

        await service.updateRelationshipPost(idEmpresa, bodyRequest);
      } else {
        const bodyRequest = {
          postoTrabalhoId: idPosto,
          saudeOcupacionalId: idSaude,
          id: idRelation,
        };

        await service.updateRelationshipPut(idEmpresa, idRelation, bodyRequest);
      }
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};
